export enum SortDirection {
  Undefined = 0,
  Asc = 1,
  Desc = 2,
}
